import type { SupVaultReward } from "@/types";
import { useStoredData } from "@/store";
import { useMemo } from "react";

export interface RewardsSettings {
  rewardsOverloadFunc?: (rewards: SupVaultReward[]) => SupVaultReward[];
  includeRewardsInApy?: boolean;
}

export default function useRewardSettings() {
  const storedData = useStoredData();

  return useMemo(
    () =>
      ({
        rewardsOverloadFunc: (rewards: SupVaultReward[]) => {
          return rewards.map(reward => {
            if (reward.is_configurable) {
              const overloadedReward = storedData.rewardTokenValuations.find(overloadedReward => overloadedReward.id === reward.address);
              if (overloadedReward) {
                return {
                  ...reward,
                  reward_rate: reward.reward_rate * overloadedReward.custom_price,
                };
              }
            }
            return reward;
          });
        },
        includeRewardsInApy: storedData.includeRewardsInApy,
      }) as RewardsSettings,
    [storedData.includeRewardsInApy, storedData.rewardTokenValuations]
  );
}
